/** OPCONF's subject type for an OPHUB contact. */
export const CONTACT_SUBJECT_TYPE = "ophub.contact";
